export interface Pager {
  page_current: number;
  pages_all: number;
  records_all: number;
  records_per_page: number;
}
